<template>
  <div class="content-center full-height">
    <div class="background-black">
      <div class="p-5 flex justify-center items-center">
        <a href="/"><img src="/images/logo_testo.png" /></a>
      </div>

      <div class="mt-1 px-8 py-3 flex justify-center items-center">
        <a href="https://streetstock.it">
          <button class="btn-indigo sconto-button" type="submit">OTTIENI LO SCONTO</button>
        </a>
      </div>
      <div style="padding: 30px 10px" class="p-2 flex justify-center items-center">
        <span class="text-white text-center font-bold text-3xl">Seguici su </span>
      </div>
      <div class="mt-1 px-8 py-3 flex justify-center items-center">
        <a href="/whatsapp" class="btn-indigo social-button">WHATSAPP</a>
      </div>
      <div class="mt-1 px-8 py-3 flex justify-center items-center">
        <a href="https://tiktok.com/@streetstockmarket1">
          <button class="btn-indigo social-button" type="submit">TIKTOK</button>
        </a>
      </div>
      <div class="mt-1 px-8 py-3 flex justify-center items-center">
        <a href="https://instagram.com/streetstock_market/">
          <button class="btn-indigo social-button" type="submit">INSTAGRAM</button>
        </a>
      </div>
      <div class="mt-1 px-8 py-3 flex justify-center items-center">
        <a href="https://www.facebook.com/streetstockitalia">
          <button class="btn-indigo social-button" type="submit">FACEBOOK</button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      options: {},
    }
  },
}
</script>

<style scoped>
/* Aggiungere altezza per coprire tutta la pagina */
.full-height {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

/* Sfondo nero per coprire tutta l'altezza */
.background-black {
  background-color: #000;
  flex-grow: 1;
  width: 100%;
}

/* Stile dei pulsanti per garantire uniformità */
.social-button {
  padding: 15px 40px;
  width: 170px; /* Larghezza fissa per garantire uniformità */
  text-align: center;
}

.sconto-button {
  padding: 15px 40px;
  width: 220px; /* Larghezza fissa per garantire uniformità */
  text-align: center;
}
</style>
